import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { Vector, isPointInside } from "tsparticles-engine";
export var NoneOutMode = /*#__PURE__*/function () {
  function NoneOutMode(container) {
    _classCallCheck(this, NoneOutMode);

    this.container = container;
    this.modes = ["none"];
  }

  _createClass(NoneOutMode, [{
    key: "update",
    value: function update(particle, direction, delta, outMode) {
      if (!this.modes.includes(outMode)) {
        return;
      }

      if (particle.options.move.distance.horizontal && (direction === "left" || direction === "right") || particle.options.move.distance.vertical && (direction === "top" || direction === "bottom")) {
        return;
      }

      var gravityOptions = particle.options.move.gravity,
          container = this.container;
      var canvasSize = container.canvas.size;
      var pRadius = particle.getRadius();

      if (!gravityOptions.enable) {
        if (particle.velocity.y > 0 && particle.position.y <= canvasSize.height + pRadius || particle.velocity.y < 0 && particle.position.y >= -pRadius || particle.velocity.x > 0 && particle.position.x <= canvasSize.width + pRadius || particle.velocity.x < 0 && particle.position.x >= -pRadius) {
          return;
        }

        if (!isPointInside(particle.position, container.canvas.size, Vector.origin, pRadius, direction)) {
          container.particles.remove(particle);
        }
      } else {
        var position = particle.position;

        if (!gravityOptions.inverse && position.y > canvasSize.height + pRadius && direction === "bottom" || gravityOptions.inverse && position.y < -pRadius && direction === "top") {
          container.particles.remove(particle);
        }
      }
    }
  }]);

  return NoneOutMode;
}();